import { Configuration, PopupRequest } from "@azure/msal-browser";
import { getAzureAdClientId, getAzureAuthority } from "./runtimeConfig";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: getAzureAdClientId() || "05eae6a0-a211-46bf-b122-644639666554",
        authority: getAzureAuthority() || "https://login.microsoftonline.com/49423d5d-8d49-4128-b53d-59537808f6ac",
        redirectUri: "/",
        postLogoutRedirectUri: "/"
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read", "User.Read.All"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
